// This object stores codes for different user activities or events.

const activityCodes = {
    pageViewed: 101,
    buttonClicked: 102,    
};

export default activityCodes;
